import { Button } from '../../../../../common/components/button/Button'
import { Input } from '../../../../../common/components/input/Input'
import classes from './Form.module.sass'
import { useForm } from './hooks/useForm'
import { SearchSelect } from '../../../../../common/components/searchSelect/SearchSelect'
import { StockDocumentInterface } from '../../../../../common/types/interfaces'
import plus from '../../../../../assets/images/icons/add.svg'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { Item } from './components/item/Item'

type Props = {
  edit: boolean
  document: Partial<StockDocumentInterface>
  setDocument: React.Dispatch<React.SetStateAction<Partial<StockDocumentInterface>>>
  getList: () => void
  setModalActive: React.Dispatch<React.SetStateAction<boolean>>
  documentType: number
  addMovement: () => void
  removeMovement: (index: number) => void
}

export const Form = ({
  edit,
  document,
  setDocument,
  getList,
  setModalActive,
  documentType,
  addMovement,
  removeMovement,
}: Props) => {
  const {
    formAction,
    inputHandler,
    setDirty,
    getValidationResult,
    disabled,
    createStoreSelectList,
    createSaleItemSelectList,
    handleMovementChange,
    getItemValidationResult,
    markFieldDirty,
  } = useForm(document, setDocument, edit, getList, setModalActive, documentType)

  return (
    <div className={classes.container}>
      <div className={classes.title}>{documentType === 0 ? 'Новый приход' : 'Новое списание'}</div>

      <Input
        type={'text'}
        fieldName={'number'}
        value={document.number || ''}
        placeHolder={'Номер документа'}
        onChangeHandler={inputHandler}
        itemValidationResult={getValidationResult('number')}
        onBlur={setDirty}
      />

      <SearchSelect
        onBlur={setDirty}
        fieldName="storeId"
        options={createStoreSelectList()}
        value={document.storeId}
        onChangeHandler={inputHandler}
        type="text"
        placeholder={'Выберите магазин'}
        itemValidationResult={getValidationResult('storeId')}
      />

      <Input
        type={'text'}
        fieldName={'comment'}
        value={document.comment || ''}
        placeHolder={'Комментарий (необязательно)'}
        onChangeHandler={inputHandler}
        itemValidationResult={getValidationResult('comment')}
        onBlur={setDirty}
      />

      <div className={classes.title}>ТОВАР</div>
      <IconButton display onClick={addMovement} icon={plus} alt="Добавить" small />

      <div className={classes.items}>
        {document.movements?.map((movement, index) => (
          <Item
            key={index}
            idx={index}
            item={movement}
            onRemove={removeMovement}
            onChange={handleMovementChange}
            onBlur={markFieldDirty} // 👈 один раз, как onBlur
            saleItemOptions={createSaleItemSelectList()}
            getItemValidationResult={getItemValidationResult}
          />
        ))}
      </div>

      <Button text={edit ? 'Сохранить' : 'Создать'} onClick={formAction} disabled={disabled} />
    </div>
  )
}
